/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest = {
  replicaVersionId: string;
};

/** @internal */
export const GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$inboundSchema:
  z.ZodType<
    GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    replica_version_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "replica_version_id": "replicaVersionId",
    });
  });

/** @internal */
export type GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$Outbound = {
  replica_version_id: string;
};

/** @internal */
export const GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$outboundSchema:
  z.ZodType<
    GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest
  > = z.object({
    replicaVersionId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      replicaVersionId: "replica_version_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$ {
  /** @deprecated use `GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$inboundSchema;
  /** @deprecated use `GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$outboundSchema;
  /** @deprecated use `GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$Outbound;
}

export function getApiV3SubnetReplicaVersionsReplicaVersionIdRequestToJSON(
  getApiV3SubnetReplicaVersionsReplicaVersionIdRequest:
    GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest,
): string {
  return JSON.stringify(
    GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$outboundSchema.parse(
      getApiV3SubnetReplicaVersionsReplicaVersionIdRequest,
    ),
  );
}

export function getApiV3SubnetReplicaVersionsReplicaVersionIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest' from JSON`,
  );
}
